"use client";
import { Box, IconButton, Stack } from "@mui/material";
import { WebShopIcon } from "@/src/components/WebShopIcon";
import { Button } from "@/src/components/Button";
import { FinmonErrorModalData } from "../../types";
import { useTextUsModalStore } from "@/src/stores/useTextUsModalStore";
import { apiCallsModalStore } from "../../modalStore";
import {useMutation} from "@tanstack/react-query";
import {addErrorLog} from "@/src/api/services/integration-log";
import {useEffect} from "react";
import {PROCESS_INSTANCE_QUERY} from "@/src/shared/const";
import {useSearchParams} from "next/navigation";

export const ApiCallsFinMonErrorModal = ({
  cancelButtonLink,
  submitButtonLink,
  error
}: FinmonErrorModalData) => {
  const openTextUsModal = useTextUsModalStore((state) => state.open);
  const { modal, close } = apiCallsModalStore();
  const searchParams = useSearchParams();
  const processInstanceId = searchParams.get(PROCESS_INSTANCE_QUERY);

  const onClose = () => {
    cancelButtonLink
      ? window.open(cancelButtonLink, "_blank")
      : window.open("https://www.pzu.com.ua/useful/filials.html", "_blank");
    close();
  };
  const onSubmit = () => {
    close();
    openTextUsModal();
  };

  const { mutate: addError} = useMutation({
    mutationFn: addErrorLog
  })

  useEffect(() => {
    error && processInstanceId && addError({
      processInstanceId,
      actionName: 'frontendErrorFinap',
      message: error.message,
      statusCode: 500,
      requestMethod: "POST",
    })
  }, [error, processInstanceId]);

  return (
    <Box className="relative flex w-full max-w-[524px] flex-col gap-6 rounded-xl bg-white p-6 shadow-xl center-modal max-md:animate-up-modal max-md:bottom-modal">
      <IconButton onClick={close} className="absolute right-4 top-4 p-2">
        <WebShopIcon name={"close"} className="fill-blue" />
      </IconButton>
      <Stack className="flex flex-col items-center justify-center gap-3 text-center text-base text-dark-gray">
        <Box
          className={
            "flex aspect-square w-[68px] items-center justify-center rounded-full bg-[#FF00000D]"
          }
        >
          <WebShopIcon
            name="triangle-alert"
            width={32}
            height={32}
            fill="#ff0000"
          />
        </Box>
        <Box className={"text-lg font-semibold text-dark-gray"}>
          Перевірку не пройдено!
        </Box>
        <Box className={"text-base text-dark-gray"}>
          Шановний клієнте! На жаль, перевірка щодо можливості укладання полісу
          страхування онлайн – не пройдена. Для оформлення страхового полісу,
          зверніться, будь ласка, до найближчого відділення ПЗУ Україна або
          замовте консультацію.
        </Box>
      </Stack>
      <Stack className="flex flex-col flex-nowrap gap-3 [&>*]:flex-1">
        <Button variant={"outlined"} onClick={onClose}>
          Мапа відділень
        </Button>
        <Button onClick={onSubmit}>Замовити консультацію</Button>
      </Stack>
    </Box>
  );
};
